import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot, UiKitToastsContextProvider } from '@cian/ui-kit';
import { ComponentProps, PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import type { Store } from 'redux';

import { IApplicationCommonRootComponentProps } from '../../types/applicationRootComponent';
import { ApplicationContext } from '../../utils/applicationContext';

const CommonContextProviders: React.FC<PropsWithChildren & IApplicationCommonRootComponentProps> = ({
  context,
  children,
  reduxStore,
}) => {
  return (
    <ErrorLogComponent logger={context.logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={context.custom.initialDeviceType}>
          <UiKitToastsContextProvider>
            <Provider store={reduxStore as Store}>{children}</Provider>
          </UiKitToastsContextProvider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};

/** HOC для объединения всех общих провайдеров в один компонент. */
export const withCommonProviders = (Component: React.FC<ComponentProps<typeof CommonContextProviders>>) => {
  const App: React.FC<ComponentProps<typeof CommonContextProviders>> = props => (
    <CommonContextProviders {...props}>
      <Component {...props} />
    </CommonContextProviders>
  );

  return App;
};
